import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "panel-title" }
const _hoisted_2 = { class: "incident-list" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "incident-list-title-row" }
const _hoisted_5 = { class: "incident-list-title" }
const _hoisted_6 = { class: "incident-list-date" }
const _hoisted_7 = ["placeholder"]
const _hoisted_8 = ["placeholder"]
const _hoisted_9 = { value: "open" }
const _hoisted_10 = { value: "investigating" }
const _hoisted_11 = { value: "resolved" }
const _hoisted_12 = { value: "closed" }
const _hoisted_13 = ["placeholder"]
const _hoisted_14 = ["placeholder"]
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "mb-2" }
const _hoisted_17 = { value: "open" }
const _hoisted_18 = { value: "investigating" }
const _hoisted_19 = { value: "resolved" }
const _hoisted_20 = { value: "closed" }
const _hoisted_21 = { class: "timeline" }
const _hoisted_22 = { class: "timeline-content" }
const _hoisted_23 = { class: "text-muted" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StateBlock = _resolveComponent("StateBlock")!
  const _component_BaseModal = _resolveComponent("BaseModal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h3", _hoisted_1, _toDisplayString(_ctx.$t('panel.incidents.log.title')), 1),
    _createElementVNode("button", {
      class: "btn btn-primary mb-3",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showCreate = true))
    }, _toDisplayString(_ctx.$t('panel.incidents.log.newIncident')), 1),
    (_ctx.incidents.length === 0)
      ? (_openBlock(), _createBlock(_component_StateBlock, {
          key: 0,
          empty: "",
          "empty-text": _ctx.$t('panel.incidents.log.empty')
        }, null, 8, ["empty-text"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.incidents, (incident) => {
        return (_openBlock(), _createElementBlock("div", {
          key: incident._id,
          class: "incident-list-card",
          onClick: ($event: any) => (_ctx.goToIncident(incident))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(incident.title), 1),
            _createElementVNode("span", {
              class: _normalizeClass(["incident-list-status", 'status-' + incident.status])
            }, _toDisplayString(_ctx.$t('panel.incidents.status.' + incident.status)), 3)
          ]),
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.formatDate(incident.createdAt)), 1)
        ], 8, _hoisted_3))
      }), 128))
    ]),
    _createVNode(_component_BaseModal, {
      show: _ctx.showCreate,
      size: "sm",
      "content-class": "incident-modal-content",
      onClose: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showCreate = false))
    }, {
      default: _withCtx(() => [
        _createElementVNode("h4", null, _toDisplayString(_ctx.$t('panel.incidents.log.createTitle')), 1),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newIncident.title) = $event)),
          class: "form-control mb-2",
          placeholder: _ctx.$t('panel.incidents.log.titlePlaceholder')
        }, null, 8, _hoisted_7), [
          [_vModelText, _ctx.newIncident.title]
        ]),
        _withDirectives(_createElementVNode("textarea", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newIncident.description) = $event)),
          class: "form-control mb-2",
          placeholder: _ctx.$t('panel.incidents.description')
        }, null, 8, _hoisted_8), [
          [_vModelText, _ctx.newIncident.description]
        ]),
        _createElementVNode("label", null, _toDisplayString(_ctx.$t('panel.incidents.statusLabel')), 1),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.newIncident.status) = $event)),
          class: "form-select mb-2"
        }, [
          _createElementVNode("option", _hoisted_9, _toDisplayString(_ctx.$t('panel.incidents.status.open')), 1),
          _createElementVNode("option", _hoisted_10, _toDisplayString(_ctx.$t('panel.incidents.status.investigating')), 1),
          _createElementVNode("option", _hoisted_11, _toDisplayString(_ctx.$t('panel.incidents.status.resolved')), 1),
          _createElementVNode("option", _hoisted_12, _toDisplayString(_ctx.$t('panel.incidents.status.closed')), 1)
        ], 512), [
          [_vModelSelect, _ctx.newIncident.status]
        ]),
        _createElementVNode("label", null, _toDisplayString(_ctx.$t('panel.incidents.dateTime')), 1),
        _withDirectives(_createElementVNode("input", {
          type: "datetime-local",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.newIncident.createdAt) = $event)),
          class: "form-control mb-2"
        }, null, 512), [
          [_vModelText, _ctx.newIncident.createdAt]
        ]),
        _createElementVNode("button", {
          class: "btn btn-primary",
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.createIncident && _ctx.createIncident(...args)))
        }, _toDisplayString(_ctx.$t('panel.incidents.log.create')), 1),
        _createElementVNode("button", {
          class: "btn btn-outline-secondary ms-2",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showCreate = false))
        }, _toDisplayString(_ctx.$t('panel.incidents.cancel')), 1)
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_BaseModal, {
      show: _ctx.showEntryModal,
      size: "sm",
      "content-class": "incident-modal-content",
      onClose: _cache[13] || (_cache[13] = ($event: any) => (_ctx.showEntryModal = false))
    }, {
      default: _withCtx(() => [
        _createElementVNode("h4", null, _toDisplayString(_ctx.$t('panel.incidents.addEntry')), 1),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.newEntry.author) = $event)),
          class: "form-control mb-2",
          placeholder: _ctx.$t('panel.incidents.author')
        }, null, 8, _hoisted_13), [
          [_vModelText, _ctx.newEntry.author]
        ]),
        _withDirectives(_createElementVNode("textarea", {
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.newEntry.message) = $event)),
          class: "form-control mb-2",
          placeholder: _ctx.$t('panel.incidents.message')
        }, null, 8, _hoisted_14), [
          [_vModelText, _ctx.newEntry.message]
        ]),
        _createElementVNode("label", null, _toDisplayString(_ctx.$t('panel.incidents.dateTime')), 1),
        _withDirectives(_createElementVNode("input", {
          type: "datetime-local",
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.newEntry.createdAt) = $event)),
          class: "form-control mb-2"
        }, null, 512), [
          [_vModelText, _ctx.newEntry.createdAt]
        ]),
        _createElementVNode("button", {
          class: "btn btn-primary",
          onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.addEntry && _ctx.addEntry(...args)))
        }, _toDisplayString(_ctx.$t('panel.incidents.addEntry')), 1),
        _createElementVNode("button", {
          class: "btn btn-outline-secondary ms-2",
          onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.showEntryModal = false))
        }, _toDisplayString(_ctx.$t('panel.incidents.cancel')), 1)
      ]),
      _: 1
    }, 8, ["show"]),
    (_ctx.selectedIncident)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createElementVNode("h4", null, _toDisplayString(_ctx.selectedIncident.title), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.selectedIncident.description), 1),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("label", null, _toDisplayString(_ctx.$t('panel.incidents.statusLabel')), 1),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.statusUpdate) = $event)),
              class: "form-select d-inline w-auto ms-2"
            }, [
              _createElementVNode("option", _hoisted_17, _toDisplayString(_ctx.$t('panel.incidents.status.open')), 1),
              _createElementVNode("option", _hoisted_18, _toDisplayString(_ctx.$t('panel.incidents.status.investigating')), 1),
              _createElementVNode("option", _hoisted_19, _toDisplayString(_ctx.$t('panel.incidents.status.resolved')), 1),
              _createElementVNode("option", _hoisted_20, _toDisplayString(_ctx.$t('panel.incidents.status.closed')), 1)
            ], 512), [
              [_vModelSelect, _ctx.statusUpdate]
            ]),
            _createElementVNode("button", {
              class: "btn btn-sm btn-primary ms-2",
              onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.updateStatus && _ctx.updateStatus(...args)))
            }, _toDisplayString(_ctx.$t('panel.incidents.update')), 1),
            _createElementVNode("button", {
              class: "btn btn-primary ms-2",
              onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.showEntryModal = true))
            }, _toDisplayString(_ctx.$t('panel.incidents.addEntry')), 1)
          ]),
          _createElementVNode("h5", null, _toDisplayString(_ctx.$t('panel.incidents.log.timeline')), 1),
          _createElementVNode("div", _hoisted_21, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedEntries, (entry) => {
              return (_openBlock(), _createElementBlock("div", {
                key: entry.id,
                class: "timeline-entry"
              }, [
                _cache[18] || (_cache[18] = _createElementVNode("div", { class: "timeline-dot" }, null, -1)),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("b", null, _toDisplayString(entry.author), 1),
                  _cache[17] || (_cache[17] = _createTextVNode()),
                  _createElementVNode("span", _hoisted_23, "(" + _toDisplayString(_ctx.formatDate(entry.createdAt)) + ")", 1),
                  _createElementVNode("div", null, _toDisplayString(entry.message), 1)
                ])
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}